<template>
    <div class="content-box first">
        <div class="fadada-box">
            <div class="url-box">
                <iframe :src="iframeUrl" scrolling="no" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeUrl: this.$route.query.url
        }
    }
}
</script>
<style lang="scss" scoped>
.fadada-box {
    display: flex;
    // align-items: center;
    // align-content: center;
    // justify-content: center;
    flex-direction: column;
    overflow: hidden;
    overflow-x: auto;

    .url-box {
        flex: 1;
        min-width: 900px;

        iframe {
            width: 100%;
            height: 800px;
        }
    }
}
</style>